var a = document.querySelectorAll('header-menu details');
  
console.log(a);
a.forEach(item => {
  const b = item.querySelector('.header__submenu')
  item.addEventListener('mouseover', () => {
    item.setAttribute('open','');
   
    b.classList.add('menu-open');
  });
  item.addEventListener('mouseleave', () => {
    item.removeAttribute('open');
    b.classList.remove('menu-open');
    
  });

  b.addEventListener('mouseover', () => {
    item.setAttribute('open','');
  
    b.classList.add('menu-open');
  });
  b.addEventListener('mouseleave', () => {
    item.removeAttribute('open');
    b.classList.remove('menu-open');
   
  });
  
})